import React, { useState, useEffect } from 'react';

export default function LoadingPanel(props) {
    
    const generateGUID = () => {
  		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    		const r = Math.random() * 16 | 0;
    		const v = c === 'x' ? r : (r & 0x3 | 0x8);
    		return v.toString(16);
  		});
	};

    const { loading = true, completeMessage = "", useMargin = true, id=generateGUID() } = props;
    
 	const loadingPanel = (
      	<div className="k-loading-mask" role="loading"
      		style={{
                  backgroundColor: "#000000",
                  opacity: "0.5"
			}}
      	>
      		<span className="k-loading-text">Loading</span>
        	<span className={"fa fa-cs-logo k-loading-image constituo-mask" + (!useMargin ? " constituo-mask-no-margin" : "")}/>
      	</div>
    );
    
    useEffect(() => {
   		setTimeout(() => {
   			const announcementElement = document.getElementById(id);
   			if (announcementElement != null) {
   				announcementElement.textContent = ""; // Clear the content
   				announcementElement.textContent = completeMessage;
   			}
   		}, 0);
    }, [loading]);
    
    
    return (
        <div className={!loading ? "constituo-visually-hidden" : ""} style={{ height: "0px" }}>
    		{loading && loadingPanel}
        	<div
        		id={id}
        		role="status" 
        		aria-live="assertive"
        		className="constituo-visually-hidden"
        	/>    		
    	</div>
    );
}